import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { BLUR_COMMAND, COMMAND_PRIORITY_EDITOR } from "lexical";
import { $generateHtmlFromNodes } from "@lexical/html";

interface CustomOnBlurPluginProps {
  onBlur: (value: Record<"json" | "html", string>) => void;
}

export default function CustomOnBlurPlugin({
  onBlur,
}: CustomOnBlurPluginProps) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.registerCommand(
      BLUR_COMMAND,
      (payload, editor) => {
        const editorState = editor.getEditorState();
        const json = editorState.toJSON();
        const jsonString = JSON.stringify(json);
        const htmlString = $generateHtmlFromNodes(editor);

        onBlur({
          json: jsonString,
          html: htmlString,
        });

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor, onBlur]);

  return null;
}
